import React, {useContext, useState} from 'react';
import {IoChevronForwardOutline, IoLocationSharp} from "react-icons/io5";
import {AppContext} from "../../Contexts/AppContext";
import {Link} from "react-router-dom";

const Group = ({uid, title, pois}) => {
    const {activeGroups, setActiveGroups} = useContext(AppContext);
    const [active, setActive] = useState(() => {
        return activeGroups.includes(uid);
    });

    const toggleGroup = ((event) => {
        if(event.target === event.currentTarget || event.target.classList.contains('clickable')) {
            if (!active) {
                setActiveGroups([...activeGroups, uid]);
            }
            else {
                setActiveGroups((current) => current.filter((item) => item !== uid));
            }
            setActive(!active);
        }
    });

    return (
        <li key={uid} onClick={toggleGroup} data-uid={uid} className={active ? "active" : ""}><IoChevronForwardOutline className="clickable" />{title}
            <ul>
                {pois.length > 0 && pois.map((poi) => {
                    return <li key={poi.uid}><IoLocationSharp /> <Link to={'poi/' + poi.slug}>{poi.title}</Link></li>
                })}
            </ul>
        </li>
    );
};

export default Group;